// The chat lines for the edition turning on and off (client/ui.js posts them like the outbreak lines).
export const HALLOWEEN_LINES = {
  on: "Halloween: some visitors wear costumes. A costume hides a face, never tonight's rule.",
  off: 'Halloween is over. Visitors lay their costumes down.',
};
